// myipb
import myipb from './../../../img/myipb-02.svg'

//Variables

function TopApps() {

    return (
        <div>
            <a className='myipbButton' href='https://my.unipb.pt' aria-label='My UPB' target='_blank' rel="noreferrer">
                <img src={myipb} alt='MyIPB logo' />
            </a>
        </div>
    )
}

export default TopApps
